import { CircularProgress, Grid, makeStyles, Typography } from '@material-ui/core'
import { Button } from 'components'
import React, { useEffect, useState } from 'react'
import API from 'api'
import { useSubBar } from 'context'

const styles = makeStyles(theme => ({
  regularSection: {
    background: theme.palette.primary.light,
    borderRadius: 8,
    padding: theme.spacing(3, 4),
    boxShadow: `0px 0px 7px 2px rgba(0, 0, 0, 0.21),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)`,
    margin: theme.spacing(1, 0),
  },
  textSpacing: {
    marginTop: `10px`,
  },
  token: {
    overflowWrap: `anywhere`,
  },
}))

export default function Intersystem() {
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)
  const [token, setToken] = useState(`asd`)
  const classes = styles()
  async function refreshToken() {
    if (saving) {
      return
    }
    setError(null)
    setSaving(true)
    try {
      const { data } = await new API({
        endpoint: `RefreshToken`,
      }).send()
      setToken(data.token)
    } catch (evt) {
      setError(evt.error?.message ?? `Error`)
    }
    setSaving(false)
  }
  async function getData() {
    try {
      const { data } = await new API({
        endpoint: `getToken`,
      }).send()
      setToken(data.token)
      setLoading(false)
    } catch (evt) {
      setError(evt.error?.message ?? `Error`)
    }
  }
  const { setSubBar } = useSubBar()

  useEffect(() => {
    getData()
    setSubBar({ type: ``, render: () => {} })
    // eslint-disable-next-line
  }, [])
  return (
    <Grid container alignItems="flex-start" alignContent="flex-start">
      {loading && <CircularProgress />}
      {!loading && (
        <Grid
          container
          alignItems="flex-start"
          alignContent="flex-start"
          className={classes.regularSection}
        >
          <Grid container direction="row" justify="space-between" alignItems="flex-start">
            <Typography variant="h2">Configuración Token Intersistema</Typography>
          </Grid>
          <Grid
            className={classes.textSpacing}
            container
            direction="row"
            justify="space-between"
            alignItems="flex-start"
          >
            <Typography>La contraseña para interactuar con la API del sistema es: </Typography>
          </Grid>
          <Grid
            className={`${classes.textSpacing} ${classes.token}`}
            container
            direction="row"
            justify="space-between"
            alignItems="flex-start"
          >
            <Typography variant={`h3`}>{token}</Typography>
          </Grid>
          <Grid
            className={classes.textSpacing}
            container
            direction="row"
            justify="space-between"
            alignItems="flex-start"
          >
            <Typography>Se recomienda actualizar este token cada 30 días por seguridad</Typography>
          </Grid>
          {error && (
            <Grid
              className={classes.textSpacing}
              container
              direction="row"
              justify="space-between"
              alignItems="flex-start"
            >
              <Typography color="error">Error al actualizar el token: {error}</Typography>
            </Grid>
          )}
          <Grid
            className={classes.textSpacing}
            container
            direction="row"
            justify="space-between"
            alignItems="flex-start"
          >
            <Button onClick={refreshToken} variant="contained" color="secondary">
              {saving ? (
                <>
                  <CircularProgress
                    style={{ marginRight: `10px`, width: `15px`, height: `15px` }}
                  />
                  {` `}
                  Actualizando Token
                </>
              ) : (
                `Actualizar Token`
              )}
            </Button>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}
